import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from '@/components/Logo';

const LINKS = [
  { label: 'Our Roster', to: '/#roster' },
  { label: 'Services', to: '/#services' },
  { label: 'Digital Production', to: '/services/digital-production' },
  { label: 'Meta Ads', to: '/meta-ads' },
  { label: 'Huntr', to: '/huntr' },
  { label: 'Rankr', to: '/rankr' },
  { label: 'Case Studies', to: '/case-studies' },
  { label: 'Partnerships', to: '/#partnerships' },
  { label: 'Contact Us', to: '/#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0B0B0B]/85 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <div className="flex flex-col leading-none shrink-0">
          <Logo />
          <span className="hidden sm:block text-[9px] uppercase tracking-[0.3em] text-white/40 mt-1">
            Agency
          </span>
        </div>

        <nav className="hidden xl:flex flex-1 items-center justify-center gap-7 mx-12 text-[13px] font-medium text-white/65">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="whitespace-nowrap leading-none hover:text-white transition-colors duration-300">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/pitch-a-brand"
            className="hidden sm:inline-flex items-center justify-center px-6 h-11 rounded-lg text-sm font-semibold border border-white/25 text-white hover:border-[#3B82F6] hover:bg-[#2563EB] hover:text-white transition-all duration-300"
          >
            Pitch a Brand
          </Link>
          <button onClick={() => setOpen((o) => !o)} className="xl:hidden text-white p-2" aria-label="Toggle menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-[#0B0B0B]/97 backdrop-blur-xl border-t border-white/10 px-6 py-6">
          <nav className="flex flex-col gap-5 text-base text-white/75">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="hover:text-[#3B82F6] transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}